module.exports = __webpack_public_path__ + "assets/images/04-active_2b45d9a84a184c7b5c418e305848798c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/04-active.png
// module id = 229
// module chunks = 0